export const isBlank = text => {
	if (!text) return true;

	if (isNaN(text)) {
		return text?.trim()?.length <= 0;
	} else {
		return `${text}`.length <= 0;
	}
};

export const getErrorMessage = (
	err,
	defaultMessage = 'خطا در ارتباط با سرور، لطفا اتصال یا ورودی خود را چک کنید'
) => {
	const serverMessage = err?.response?.data?.message;

	if (serverMessage) {
		if (typeof serverMessage === 'object') {
			let finalMessage = '';
			const keys = Object.keys(serverMessage);
			keys.forEach((key) => {
				finalMessage += `${key} : ${serverMessage[key]}`;
			});
			return finalMessage;
		} else {
			return serverMessage;
		}
	} else {
		return defaultMessage;
	}
};

export function getStringColor(stringInput) {
	if ((stringInput?.length ?? 0) <= 0) return '#000';

    const stringUniqueHash = [...stringInput].reduce((acc, char) => {
        return char.charCodeAt(0) + ((acc << 5) - acc);
    }, 0);

    return `hsl(${stringUniqueHash % 360}, 95%, 35%)`;
}

export const getUserTypeLabel = (userType) => {
	switch (parseInt(userType)) {
		case 0:
			//company
			return 'شرکت های تعاونی';
			break;
		case 1:
			//union
			return 'اتحادیه استانی';
			break;
		case 2:
			//admin
			return 'مدیریت کشوری';
		default:
			return 'نامشخص';
	}
};